import { CHUNK_HEIGHT, CHUNK_SIZE, CHUNK_VOLUME } from "../config";
import { Block } from "./blocks";

export function chunkKey(cx: number, cz: number): string {
  return `${cx},${cz}`;
}

export function parseChunkKey(key: string): { cx: number; cz: number } {
  const [a, b] = key.split(",");
  return { cx: Number(a), cz: Number(b) };
}

export function worldToChunk(n: number): number {
  return Math.floor(n / CHUNK_SIZE);
}

export function worldToLocal(n: number): number {
  return ((n % CHUNK_SIZE) + CHUNK_SIZE) % CHUNK_SIZE;
}

export function blockIndex(x: number, y: number, z: number): number {
  return x + z * CHUNK_SIZE + y * CHUNK_SIZE * CHUNK_SIZE;
}

export class Chunk {
  readonly cx: number;
  readonly cz: number;
  readonly blocks: Uint16Array;
  readonly biomes: Uint8Array;
  readonly heights: Uint8Array;
  dirty = true;
  generated = false;
  meshId = 0;

  constructor(cx: number, cz: number) {
    this.cx = cx;
    this.cz = cz;
    this.blocks = new Uint16Array(CHUNK_VOLUME);
    this.biomes = new Uint8Array(CHUNK_SIZE * CHUNK_SIZE);
    this.heights = new Uint8Array(CHUNK_SIZE * CHUNK_SIZE);
  }

  get(x: number, y: number, z: number): number {
    if (x < 0 || z < 0 || y < 0 || x >= CHUNK_SIZE || z >= CHUNK_SIZE || y >= CHUNK_HEIGHT) {
      return Block.AIR;
    }
    return this.blocks[blockIndex(x, y, z)]!;
  }

  set(x: number, y: number, z: number, id: number): void {
    if (x < 0 || z < 0 || y < 0 || x >= CHUNK_SIZE || z >= CHUNK_SIZE || y >= CHUNK_HEIGHT) {
      return;
    }
    this.blocks[blockIndex(x, y, z)] = id;
    this.dirty = true;
  }

  biomeAt(x: number, z: number): number {
    return this.biomes[x + z * CHUNK_SIZE] ?? 0;
  }

  heightAt(x: number, z: number): number {
    return this.heights[x + z * CHUNK_SIZE] ?? 0;
  }

  adopt(blocks: Uint16Array, biomes: Uint8Array, heights: Uint8Array): void {
    this.blocks.set(blocks);
    this.biomes.set(biomes);
    this.heights.set(heights);
    this.generated = true;
    this.dirty = true;
  }
}

export function inChunkBounds(x: number, y: number, z: number): boolean {
  return x >= 0 && z >= 0 && y >= 0 && x < CHUNK_SIZE && z < CHUNK_SIZE && y < CHUNK_HEIGHT;
}
